module.exports = __webpack_public_path__ + "1d5b07c2ac2283614e51a6c0339e7aa4.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_3_0.woff2
// module id = 537
// module chunks = 0